import { InjectionToken } from '@angular/core';

import { GlobalConfig } from './toast.config';

export const TOAST_CONFIG = new InjectionToken<GlobalConfig>('ToastConfig');



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/alerts/toast/toast.token.ts